import { apiPaths, RefreshIntervalsEnum } from 'configs/apiConfigs'
import useSWR, { SWRConfiguration } from 'swr'
import { httpClaims } from 'utils/http'

export const useServiceUnavailable = (config?: SWRConfiguration) => {
  const { data, error } = useSWR(apiPaths.health(), async () => await httpClaims.get(apiPaths.health()), {
    errorRetryInterval: RefreshIntervalsEnum.useServiceUnavailable,
    shouldRetryOnError: true,
    onSuccess: () => {
      window.location.reload()
    },
    ...config,
  })

  return {
    data,
    loading: !data && !error,
    error,
  }
}
